const CODE = {
  // SUCCESS: 200,
  ACCOUNT_NOT_REGISTERD: 210,
  DUPLICATE_EMAIL: 211,
  DUPLICATE_NICKNAME: 212,
  INVALID_CREDENTIALS: 213,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  TOKEN_EXPIRED: 419,
};

export default CODE;
